import { gql } from "@apollo/client";

export const GET_BOOK_DATA = gql`
    query ElibBookData($id: ID!) {
        book (
            id: $id
        ) {
            id
            shortBibl
        }
    }
`;

export const GET_ELIB_DOC = gql`
    query ElibReaderDoc($id: ID!) {
        elibReaderDoc (
            id: $id
        ) {
            id
            title
            content
            delta
            created_at
            updated_at
            deleted_at
            deleted
        }
    }
`;
 
export const GET_ELIB_DOC_DATA = gql`
    query ElibReaderDocData($first: Int!, $page: Int!, $deleted: Int, $mode: Boolean) {
        elibReaderDocData (
            first: $first
            page: $page
            deleted: $deleted
            mode: $mode
        ) {
            data {
                id
                title
                content
                delta
                created_at
                updated_at
                deleted_at
                deleted
            }
            paginatorInfo {
                total
                count
                currentPage
                lastItem
                lastPage
                firstItem
                hasMorePages
            }
        }
    }
`;

export const GET_ELIB_DOC_CREATE = gql`
    mutation ElibReaderDocCreate($title: String!, $content: String!, $delta: String!, $create_book: Int!) {
        elibReaderDocCreate(
            input: { 
                title: $title
                content: $content
                delta: $delta
                create_book: $create_book
            }
        ) {
            id
            result
        }
    }
`;

export const GET_ELIB_DOC_UPDATE = gql`
    mutation ElibReaderDocUpdate($id: ID!, $title: String!, $content: String!, $delta: String!) {
        elibReaderDocUpdate(
            id: $id 
            input: { 
                title: $title
                content: $content
                delta: $delta
            }
        ) {
            result
        }
    }
`;

export const GET_ELIB_DOC_DELETE = gql`
    mutation ElibReaderDocDelete($id: ID!) {
        elibReaderDocDelete(
            id: $id
        ) {
            result
        }
    }
`;

export const GET_ELIB_LIMIT = gql`
    query ElibReaderLimit($user_id: Int!, $book_id: Int!){
        elibReaderLimit(
            user_id: $user_id
            book_id: $book_id
        ) {
            count
        }
    }
`;

export const GET_ELIB_LIMIT_UPDATE_OR_CREATE = gql`
    mutation ElibReaderLimitUpdateOrCreate($user_id: ID!, $book_id: ID!, $content: String!) {
        elibReaderLimitUpdateOrCreate(
            input: { 
                user_id: $user_id
                book_id: $book_id
                content: $content
            }
        ) {
            count
            result
        }
    }
`;

export const GET_ELIB_COMMENT = gql`
    query ElibReaderComment($id: ID!) {
        elibReaderComment (
            id: $id
        ) {
            id
            content
            created_at
            updated_at
            deleted_at
            deleted
            pages
            str
        }
    }
`;
 
export const GET_ELIB_COMMENT_DATA = gql`
    query ElibReaderCommentData($first: Int!, $page: Int!, $deleted: Int) {
        elibReaderCommentData (
            first: $first
            page: $page
            deleted: $deleted
        ) {
            data {
                id
                content
                created_at
                updated_at
                deleted_at
                deleted
                pages
                str
            }
            paginatorInfo {
                total
                count
                currentPage
                lastItem
                lastPage
                firstItem
                hasMorePages
            }
        }
    }
`;

export const GET_ELIB_COMMENT_CREATE = gql`
    mutation ElibReaderCommentCreate($title: String!, $content: String!) {
        elibReaderCommentCreate(
            input: { 
                content: $content
            }
        ) {
            id
            result
        }
    }
`;

export const GET_ELIB_COMMENT_UPDATE = gql`
    mutation ElibReaderCommentUpdate($id: ID!, $content: String!) {
        elibReaderCommentUpdate(
            id: $id 
            input: { 
                content: $content
            }
        ) {
            result
        }
    }
`;

export const GET_ELIB_COMMENT_DELETE = gql`
    mutation ElibReaderCommentDelete($id: ID!) {
        elibReaderCommentDelete(
            id: $id
        ) {
            result
        }
    }
`;